import newSpActivityDialogTemplate from './newSpActivityDialog.html';
import newSpActivityFormTemplate from './newSpActivityForm.html';

angular
   .module('org.saga.newspactivity', ['isolateForm'])
   .directive('newSpActivity', [
      function () {
         return {
            restrict: 'E',
            template: newSpActivityFormTemplate,
            scope: {
               newActivity: '=',
               newActivityForm: '='
            },
            controller: [
               '$scope',
               function ($scope) {
                  $scope.today = new Date();
               }
            ]
         };
      }
   ])

   .factory('NewSpActivityDialog', [
      '$mdDialog',
      function ($mdDialog) {
         return {
            show: function (activity, callback) {
               function DialogController($scope, $log, $mdDialog) {
                  $scope.activity = activity;
                  $scope.cancel = function () {
                     $mdDialog.cancel();
                  };

                  $scope.ok = function () {
                     $scope.error = false;

                     $mdDialog.hide($scope.activity);
                  };
               }

               $mdDialog
                  .show({
                     controller: ['$scope', '$log', '$mdDialog', DialogController],
                     template: newSpActivityDialogTemplate,
                     parent: angular.element(document.body),
                     clickOutsideToClose: false
                  })
                  .then(
                     function (answer) {
                        callback(answer);
                     },
                     function () {
                        // callback is not called
                     }
                  );
            }
         };
      }
   ]);
